export default __webpack_public_path__ + "static/media/camview-thumb-fhd.4887dbe8.webp";